export const EMPLOYEE_DATA = [
  {
    id: Math.random(),
    firstName: "Raashi",
    lastName: "Bhutani",
    address: "B-107, A, Mansa Ram Park",
    email: "tushar.dhankhar@gmail.com",
    mobile: "0650690149",
    dob: "26/08/1979",
    image: "https://lh3.googleusercontent.com/a/ACg8ocKmPrWGxNjerqDzk5ZT8bMMPE8bu_a-1_d4OGPxUWUt6YatfYbI1A=s260-c-no",
  },
  {
    id: Math.random(),
    firstName: "Aryan",
    lastName: "Sharma",
    address: "C-305, Vishal Nagar",
    email: "aryan.sharma@example.com",
    mobile: "9876543210",
    dob: "15/05/1992",
    image: "",
  },
  {
    id: Math.random(),
    firstName: "Neha",
    lastName: "Kapoor",
    address: "H-100, Janak Puri",
    email: "neha.kapoor@example.com",
    mobile: "9876543211",
    dob: "12/03/1987",
    image: "",
  },
  {
    id: Math.random(),
    firstName: "Karan",
    lastName: "Verma",
    address: "A-22, Green Park",
    email: "karan.verma@example.com",
    mobile: "9876543212",
    dob: "25/12/1985",
    image: "",
  },
  {
    id: Math.random(),
    firstName: "Anjali",
    lastName: "Singh",
    address: "D-55, Rajendra Nagar",
    email: "anjali.singh@example.com",
    mobile: "9876543213",
    dob: "09/09/1990",
    image: "",
  },
];
